var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "jTimeLine-group",
      staticStyle: { "margin-left": "30px", width: "500px" }
    },
    [
      _c(
        "div",
        { staticClass: "bdc-approved first last noSub node child table" },
        [
          _c("div", { staticClass: "first last groupBox item" }, [
            _c(
              "div",
              { staticClass: "last groupData m-t-5" },
              [
                _vm._l(_vm.data_flow.data_position, function(i, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "noSub approved node child table"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "item ",
                          class: [index === 0 ? "first" : ""]
                        },
                        [
                          _c("div", {
                            staticClass: "approved lineBottom",
                            class: [index === 0 ? "first" : ""]
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "td" },
                            [
                              i.photo
                                ? _c("b-img", {
                                    staticClass:
                                      "m-1 round-bordered-img\n                img-circle staff-img image-popup-link b-page-theme td",
                                    attrs: {
                                      src: i.photo,
                                      rounded: "circle",
                                      alt: "img"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !i.photo
                                ? _c("b-img", {
                                    staticClass:
                                      "m-1 round-bordered-img\n                img-circle staff-img image-popup-link b-page-theme td",
                                    attrs: {
                                      src: require("../../assets/logo/user1.png"),
                                      rounded: "circle",
                                      alt: "img"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "td p-l-5 p-t-15",
                              staticStyle: { width: "375px" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "grid",
                                    "padding-top": "5px"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "no-margin c-grey ellipsis"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(i.first_name) +
                                          "\n                  " +
                                          _vm._s(i.last_name)
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "no-margin c-page-theme ellipsis"
                                    },
                                    [_vm._v(_vm._s(i.position))]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "td",
                              staticStyle: { "padding-top": "10px" },
                              on: {
                                click: function($event) {
                                  _vm.deletePositionByDivision(index)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-trash fa-2x" })]
                          )
                        ]
                      )
                    ]
                  )
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { "margin-top": "5px" } },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "7" } },
                          [
                            _c("j-single-select", {
                              attrs: {
                                "is-async": true,
                                "load-options": _vm.loadOptionsPosition,
                                "default-options": false,
                                placeholder: "Position",
                                "value-format": "object",
                                label: "name"
                              },
                              model: {
                                value: _vm.$v.data_flow.position.$model,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.$v.data_flow.position,
                                    "$model",
                                    $$v
                                  )
                                },
                                expression: "$v.data_flow.position.$model"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          {
                            staticStyle: { "padding-left": "0px" },
                            attrs: { md: "3" }
                          },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "btn blue outline",
                                on: { click: _vm.addPositionByDivision }
                              },
                              [_c("i", { staticClass: "fa fa-plus" })]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              2
            ),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "p-l-5 p-t-5" },
              [
                _c("div", { staticClass: "no-margin c-grey" }, [
                  _vm._v("Flow Type")
                ]),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "7" } },
                      [
                        _c("j-single-select", {
                          attrs: {
                            options: _vm.flow_type,
                            label: "name",
                            "value-format": "object",
                            placeholder: "Flow Type"
                          },
                          model: {
                            value: _vm.$v.data_flow.type.$model,
                            callback: function($$v) {
                              _vm.$set(_vm.$v.data_flow.type, "$model", $$v)
                            },
                            expression: "$v.data_flow.type.$model"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72ba383d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72ba383d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/division/jDivisionFlow.vue
// module id = null
// module chunks = 